import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './lib/query-client.js';
import { router } from './router.js';

export function App(): React.JSX.Element {
  // After Discord OAuth the API redirects to /#csrf=<token>.
  // The CSRF token is fetched from /api/auth/me by bootstrap(), so the
  // fragment is redundant. Strip it immediately to avoid leaking it via
  // the browser history or the Referer header on subsequent navigations.
  useEffect(() => {
    if (window.location.hash.startsWith('#csrf=')) {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search,
      );
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
